export default "__VITE_ASSET__O5RjIDZK__"